import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Console = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Console" {...props}>
    <path d="M18 16C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18H6C5.44772 18 5 17.5523 5 17C5 16.4477 5.44772 16 6 16H18Z" fill="#000" /><path d="M6.29297 6.29297C6.68349 5.90245 7.3165 5.90246 7.70703 6.29297L10.707 9.29297C10.8946 9.48051 11 9.73478 11 10C11 10.2652 10.8946 10.5195 10.707 10.707L7.70703 13.707C7.3165 14.0975 6.68349 14.0975 6.29297 13.707C5.90246 13.3165 5.90245 12.6835 6.29297 12.293L8.58594 10L6.29297 7.70703C5.90245 7.31651 5.90246 6.6835 6.29297 6.29297Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M18 1C20.7614 1 23 3.23858 23 6V18C23 20.7614 20.7614 23 18 23H6C3.23858 23 1 20.7614 1 18V6C1 3.23858 3.23858 1 6 1H18ZM6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3H6Z" fill="#000" />
  </StyledIcon>
));

Console.displayName = 'Console';

export { Console };
